export default {
  projects: {
    list: [],
    total: 0
  },

  currentProject: {}
}
